module.exports = __webpack_public_path__ + "img/history.d8c947e4.jpg";